// @flow
import * as React from "react";
import SelectDialog from "./SelectDialog";
import type { valueType, Option } from "./SelectDialog";
import Theme from "../Theme";
import { IconDropDownArrow } from "../Icons";

export type Props = {
  placeholder: ?string,
  options: Array<Option>,
  value: ?valueType,
  onOptionTapped?: ?(Option) => void,
  onBackgroundTapped?: ?() => void,
  onRequestClose?: ?() => void,
  labelStyle?: ?any,
  style?: ?any,
  open: boolean,
};

export default class SelectWithoutTappable extends React.Component<Props> {
  static defaultProps = {
    options: [],
  };

  render() {
    const {
      placeholder,
      options,
      value,
      onOptionTapped,
      onBackgroundTapped,
      onRequestClose,
      labelStyle,
      style,
      open,
    } = this.props;

    let valueLabel = "";
    const selectedOption = options.find((option) => option.value === value);
    const hasPivotSubtitle =
      selectedOption && selectedOption.label && selectedOption.isPivot;
    if (selectedOption) {
      valueLabel = selectedOption.label;
    } else {
      valueLabel = placeholder || "Select A Value";
    }

    const styles = {
      wrapper: {
        display: "inline-block",
        ...style,
      },
      labelWrapper: {
        ...Theme.Styles.flexLayout,
        lineHeight: "1em",
        minWidth: "3em",
        outline: "none",
        textTransform: style && style.textTransform,
      },
      label: {
        whiteSpace: placeholder ? "initial" : "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "inline-block",
        verticalAlign: "bottom",
        lineHeight: hasPivotSubtitle ? "1.2em" : "2em",
        textAlign: hasPivotSubtitle ? "right" : "",
        ...Theme.Styles.flexStretch,
        ...labelStyle,
      },
      icon: {
        ...Theme.Styles.flexFixed,
        fontSize: "1.35em",
        paddingLeft: "0.25em",
      },
    };

    // Placeholders (labels) are placed at the top as a default and are not selectable
    let newOptions = placeholder
      ? [
          {
            id: "_default",
            value: "_default",
            label: placeholder,
            onClick: () => onBackgroundTapped && onBackgroundTapped(),
          },
          ...options,
        ]
      : options;

    return (
      <div data-component-name="Select" style={styles.wrapper}>
        <div style={styles.labelWrapper}>
          <span className="value" style={styles.label}>
            {valueLabel}
          </span>
          <IconDropDownArrow style={styles.icon} />
        </div>
        <SelectDialog
          options={newOptions}
          value={value}
          onOptionTapped={onOptionTapped}
          onBackgroundTapped={onBackgroundTapped}
          onRequestClose={onRequestClose}
          open={open}
        />
      </div>
    );
  }
}

export { SelectDialog };



// WEBPACK FOOTER //
// ../nx-components/src/Select/SelectWithoutTappable.jsx